export default "__VITE_ASSET__9aa58c01__"